import user from "./user";
const tpo = [
  {
    path: 'index',
    name: 'ToeflRouter',
    component: resolve => require(['@/view/toefl/home/Index'], resolve),
    meta: {
      title: '知学君',
      requireAuth: true
    }
  },
  {
    path: 'tpo/exam',
    name: 'MockRouter',
    component: resolve => require(['@/view/toefl/tpo/exam'], resolve),
    meta: {
      title: '知学君',
      requireAuth: true
    }

  },
  {
    path: 'tpo/reading',
    name: 'TPO阅读',
    component: resolve => require(['@/view/toefl/tpo/reading'], resolve),
    meta: {
      title: '知学君',
      requireAuth: true
    }
  },

  {
    path: 'tpo/speaking',
    name: 'TPO口语',
    component: resolve => require(['@/view/toefl/tpo/speaking'], resolve),
    meta: {
      title: '知学君',
      requireAuth: true
    }
  },
  {
    path: 'tpo/listening',
    name: 'TPO听力',
    component: resolve => require(['@/view/toefl/tpo/listening'], resolve),
    meta: {
      title: '知学君',
      requireAuth: true
    }
  },
  {
    path: 'tpo/writing',
    name: 'TPO写作',
    component: resolve => require(['@/view/toefl/tpo/writing'], resolve),
    meta: {
      title: '知学君',
      requireAuth: true
    }
  }, {
    path: 'undisclosed/exam',
    name: 'MockExamRouter',
    component: resolve => require(['@/view/toefl/undisclosed/exam'], resolve),
    meta: {
      title: '在考真题套题模考',
      requireAuth: true
    }

  },
  {
    path: 'undisclosed/reading',
    name: '真题阅读',
    component: resolve => require(['@/view/toefl/undisclosed/reading'], resolve),
    meta: {
      title: '知学君',
      requireAuth: true
    }

  },
  {
    path: 'undisclosed/listening',
    name: '听力真题',
    component: resolve => require(['@/view/toefl/undisclosed/listening'], resolve),
    meta: {
      title: '知学君',
      requireAuth: true
    }
  },
  {
    path: 'undisclosed/speaking',
    name: '口语真题',
    component: resolve => require(['@/view/toefl/undisclosed/speaking'], resolve),
    meta: {
      title: '知学君',
      requireAuth: true
    }
  },
  {
    path: 'undisclosed/writing',
    name: '写作真题',
    component: resolve => require(['@/view/toefl/undisclosed/writing'], resolve),
    meta: {
      title: '知学君',
      requireAuth: true
    }
  },
  {
    path: 'testReport',
    name: '测试报告',
    component: resolve => require(['@/view/toefl/testReport/index'], resolve),
    meta: {
      title: '知学君',
      requireAuth: true
    }
  },
  {
    path: 'browse',
    name: '浏览试题',
    component: resolve => require(['@/view/toefl/browse/index'], resolve),
    meta: {
      title: '知学君',
      requireAuth: true
    }
  },
  {
    path: 'search',
    name: '浏览试题',
    component: resolve => require(['@/view/toefl/search/index'], resolve),
    meta: {
      title: '知学君',
      requireAuth: true
    }
  },
  {
    path: 'detail/reading',
    name: '阅读练习',
    component: resolve => require(['@/view/toefl/detail/reading'], resolve),
    meta: {
      title: '知学君',
      requireAuth: true
    }
  },
  {
    path: 'detail/writing',
    name: '写作练习',
    component: resolve => require(['@/view/toefl/detail/writing'], resolve),
    meta: {
      title: '知学君',
      requireAuth: true
    }
  },
  {
    path: 'detail/listening',
    name: '听力练习',
    component: resolve => require(['@/view/toefl/detail/listening'], resolve),
    meta: {
      title: '知学君',
      requireAuth: true
    }
  },
  {
    path: 'detail/speaking',
    name: '口语练习',
    component: resolve => require(['@/view/toefl/detail/speaking'], resolve),
    meta: {
      title: '知学君',
      requireAuth: true
    }
  },
  {
    path: 'user',
    redirect: 'user/profile/Home',
    component: resolve => require(['@/view/toefl/user/Index'], resolve),
    children: user
  }
  
 
  
]
export default tpo;


// WEBPACK FOOTER //
// ./src/router/toefl/tpo.js